module.exports = __webpack_public_path__ + "assets/img/header.124f068e.png";